import { createAction } from "redux-actions";
import { GET_TRANSACTIONS_PAYMENT_TRAY,
    GET_TRANSACTIONS_CHARGES_TRAY,
    GET_TRANSACTIONS_OTP_PAYMENT,
    UPDATE_TRANSACTIONS_PAYMENT_TRAY,
    UPDATE_TRANSACTIONS_CHARGES_TRAY} from "../constants";
import { serverGetUserCodes, serverOTPValidate, serverOTPCompare, serverRefusePayment, serverCancelPayment } from "./../services/user-codes";
// import { userActions } from "./../api/Auth";
import { urlUserCodes, urlTransactions } from "./../services/urls";



export const getUserCodes = createAction(GET_TRANSACTIONS_PAYMENT_TRAY, (field, cedule) => 
    serverGetUserCodes(urlUserCodes, 'COBROS', field,  cedule )())

export const getUserCodesCharges = createAction(GET_TRANSACTIONS_CHARGES_TRAY, (field, request) => 
    serverGetUserCodes(urlUserCodes, 'COBROS', field,  request )())


export const validateOTP = createAction(GET_TRANSACTIONS_OTP_PAYMENT, (serie, imei, cedule, amount, otp, sequence) => 
    serverOTPValidate(urlTransactions, 'OTPPAY', serie, imei, cedule, amount, otp,  'COBROS' , sequence)())
    // GET_TRANSACTIONS_COMPARE_OTP_PAYMENT
export const compareOTP = createAction(UPDATE_TRANSACTIONS_PAYMENT_TRAY, (serie, imei, cedule, otp, request) => 
    serverOTPCompare(urlTransactions, serie, imei, cedule, otp, request )())

export const refusePayment = createAction(UPDATE_TRANSACTIONS_PAYMENT_TRAY, (otp, request, cedule, description) => 
    serverRefusePayment(urlTransactions, otp, cedule, request, description )())

export const cancelPayment = createAction(UPDATE_TRANSACTIONS_CHARGES_TRAY, (id, checked) => 
    serverCancelPayment(urlUserCodes, id, checked )())